import React, { useEffect, useState } from "react";
import NewNote from "../../../../components/NewNote";
import CandiDateNewNote from "../../../../components/CandiDateNewNote";
import { getAllNotes } from "../../../../api/candidiate";
import { useSelector } from "react-redux";

const MarketingNotes = () => {
  const [notesData, setNotesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const candidateId = useSelector(state => state.personal.candidateId);

  const fetchNotes = async () => {
    if (!candidateId) return;
    setIsLoading(true);
    try {
      const res = await getAllNotes({ genericId: candidateId, recordType: 'Marketing' });
      setNotesData(res.data?.data?.records || []);
    } catch (error) {
      console.error('Error fetching marketing notes:', error);
      setNotesData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (candidateId) {
      fetchNotes();
    }
  }, [candidateId]);

  return (
    <div className="">
      <div className="w-full px-6 flex-col justify-start items-start gap-6 inline-flex font-normal mt-5">
        <div className="flex flex-col gap-4 w-full">
          {/* Always show the add note input at the top */}
          <NewNote noteType='Marketing' fetchData={fetchNotes} />

          {/* Display existing notes */}
          {isLoading ? (
            <p className="text-sm text-gray-400">Loading notes...</p>
          ) : notesData.length > 0 ? (
            notesData.map((card) => (
              <CandiDateNewNote notesData={card} key={card.notes_id} />
            ))
          ) : (
            <p className="text-sm text-gray-400">No notes yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarketingNotes;
